import { useMemo } from "react";

// Per-render counter (page lifecycle). Reset při reloadu / navigaci.
const counters = new Map<string, number>();

export function resetAdCounters() {
  counters.clear();
}

export function useAdFrequency(placement: string, maxPerPage?: number) {
  return useMemo(() => {
    if (!maxPerPage) return { allowed: true };
    const used = counters.get(placement) ?? 0;
    if (used >= maxPerPage) return { allowed: false };
    counters.set(placement, used + 1);
    return { allowed: true };
  }, [placement, maxPerPage]);
}
